<template>
  <div id="profit">
    <div class="prohead" >
      <div>
        <el-date-picker
          v-model="para.startDate"
          type="date"
          @change="handleSearch('起始时间', para.startDate)"
          placeholder="起始时间"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd">
        </el-date-picker>

        <el-date-picker
          v-model="para.endDate"
          type="date"
          @change="handleSearch('结束时间', para.endDate)"
          placeholder="结束时间"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="comond_btn">
        <el-button  @click="handleSet('生成汇率差额报表', null)" >生成汇率差额报表</el-button>
        <el-button  @click="handleSet('调整基础汇率数据', null)" >调整基础汇率数据</el-button>
      </div>
    </div>
    <template>
        <el-table
          :data="list"
          style="width: 100%">

          <el-table-column
            label="采购订单号">
            <template slot-scope="scope">
              <div>{{ scope.row.contractNum }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="商品名称">
            <template slot-scope="scope">
              <div>{{ scope.row.goodsName }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="净重">
            <template slot-scope="scope">
              <div>{{ scope.row.netWeight }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="单价(币种)">
            <template slot-scope="scope">
              <div>{{ scope.row.purchaseTwo + scope.row.currency }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="付汇汇率">
            <template slot-scope="scope">
              <div>{{ scope.row.pExchangeRate }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="清关汇率">
            <template slot-scope="scope">
              <div>{{ (scope.row.sExchangeRate) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="付汇盈亏">
            <template slot-scope="scope">
              <div>{{ (scope.row.exchangeProfit) }}</div>
            </template>
          </el-table-column>

           <el-table-column
            label="关税盈亏">
            <template slot-scope="scope">
              <div>{{ (scope.row.tariffProfit) }}</div>
            </template>
          </el-table-column>

           <el-table-column
            label="增值税盈亏">
            <template slot-scope="scope">
              <div>{{ (scope.row.addedTaxProfit) }}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="小计">
            <template slot-scope="scope">
              <div>{{ scope.row.subtotal }}</div>
            </template>
          </el-table-column>
          
          <el-table-column
            width=""
            label="操作选项">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="handleSet('查看', scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      <div class="flexright">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="(value) => {return handleSearch('分页', value)}"
          :current-page="para.pageIndex"
          :total="total">
        </el-pagination>
        <div>总计: {{ totalPrice }}</div>
      </div>
    </template>

     <el-dialog
      :title="dialogPara.title"
      :visible.sync="dialogPara.isShowDialog"
      :width="dialogPara.width"
      center>
      <el-form :model="form">
        
        <template v-if="currentStatus === '生成汇率差额报表'">
          <div class="prohead">
            <el-form-item label="开始时间">
              <el-date-picker
                v-model="form.startTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="结束时间">
              <el-date-picker
                v-model="form.endTime"
                type="date"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="增值税税率">
              <el-select v-model="form.taxRate" placeholder="请选择" @focus="postdictionariesqueryDictionaryData(7)">
                <el-option
                  v-for="item in taxRateList"
                  :key="item.key"
                  :label="item.dictDataValue"
                  :value="item.dictDataValue">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

           <div class="prohead">
            <el-form-item label="关税税率">
              <el-select v-model="form.tariffRate" placeholder="请选择" @focus="postdictionariesqueryDictionaryData(8)">
                <el-option
                  v-for="item in tariffRateList"
                  :key="item.key"
                  :label="item.dictDataValue"
                  :value="item.dictDataValue">
                </el-option>
              </el-select>
            </el-form-item>
           </div>
        </template>

        <template v-if="currentStatus === '调整基础汇率数据'">
          <div class="prohead">
            <el-form-item label="进口关税">
              <el-input  v-model="form.importTariff" placeholder="进口关税"/> 
            </el-form-item>
          </div>

           <div class="prohead">
            <el-form-item label="进口增值税">
              <el-input  v-model="form.importAddedTax" placeholder="进口增值税"/> 
            </el-form-item>
           </div>
        </template>

        <!-- 查看 -->
        <template v-if="currentStatus === '查看'">

          <div class="prohead">
            <el-form-item label="采购合同号">{{ form.contractNum }}</el-form-item>
            <el-form-item label="商品名称">{{ form.goodsName }}</el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="型号">{{ form.model }}</el-form-item>
            <el-form-item label="重量(净重)">{{ form.netWeight }}</el-form-item>
          </div>

          <div class="prohead" v-for="item in form.batchs" :key="item.key">
            <el-form-item label="批号">{{ item.lotNum }}</el-form-item>
            <el-form-item label="批号净重">{{ item.netWeight }}</el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="单价">{{ form.purchaseTwo }}</el-form-item>
            <el-form-item label="清关税率">{{ form.sExchangeRate }}</el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="付汇税率">{{ form.pExchangeRate }}</el-form-item>
            <el-form-item label="付汇盈亏">{{ form.exchangeProfit }}</el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="关税盈亏">{{ form.tariffProfit }}</el-form-item>
            <el-form-item label="增值税盈亏">{{ form.addedTaxProfit }}</el-form-item>
          </div>

          <div class="prohead">
            <el-form-item label="小计">{{ form.subtotal }}</el-form-item>
          </div>
           
        </template>

      </el-form>
       <span slot="footer" class="dialog-footer">
          <el-button @click="dialogPara.isShowDialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSucess">确 定</el-button>
      </span>
     </el-dialog>

  </div>
</template>

<script>
import { profitlist, profitdetail, profitupdateBasic, dictionariesqueryDictionaryData, excelgetexcel } from '../../api'
export default {
  data () {
    return {
      para: {
        startDate: '',
        endDate: '',
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      totalPrice: 0,
      dialogPara: { //  弹出框配置
        isshow: false, //  默认不显示参数
        isShowDialog: false, //  默认关闭弹出框
        title: '', //  弹出框标题
        rules: null, //  规则
        width: '50%',
      },
      currentStatus: '',
      form: {},
      taxRateList: [],
      tariffRateList: [],
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    handleSearch (type, row) {
      if (type === '分页') {
        this.para.pageIndex = row
      }
      this.getlist()
    },
    handleSet (type, val) {
      this.currentStatus = type
      this.dialogPara.title = type
      this.dialogPara.width = '50%'
      console.log(type, val)
      switch (type) {
      case '查看':
        this.getdetail(val.id)
        this.dialogPara.isShowDialog = true
        break
      case '生成汇率差额报表':
        this.dialogPara.width = '30%'
        this.form = {}
        this.dialogPara.isShowDialog = true
        break
      case '调整基础汇率数据':
        this.dialogPara.width = '30%'
        this.form = {}
        this.dialogPara.isShowDialog = true
        break
      }
    },
    handleSucess () {
      switch (this.currentStatus) {
        case '查看':
          this.dialogPara.isShowDialog = false
          break
        case '生成汇率差额报表':
          this.postexcelgetexcel()
          break
        case '调整基础汇率数据':
          this.postprofitupdateBasic()
          break
      }
    },
    getlist () {
      profitlist(this.para).then(res => {
        console.log(res)
        
        let { data, msg, code } = res.data
        if (code === 10000) {
          this.list = data.rows
          this.total = data.total
          this.totalPrice = data.totalPrice
        } else {
          this.$message.error(msg)
        }
      })
    },
    getdetail (id) {
      console.log(id)
      let para = new URLSearchParams({'id':id})
      profitdetail(para).then(res => {
        console.log(res)
        let { data, msg, code } = res.data
        if (code === 10000) {
          this.form = data
        } else {
          this.$message.error(msg)
        }
      })
    },
    postprofitupdateBasic () { //  调整基础汇率数据
      let para = new URLSearchParams(this.form)
      profitupdateBasic(para).then(res => {
        console.log(res)
        let { code, data, msg } = res
        if (code === 10000) {
          this.getlist()
          this.$message.success(msg)
          this.dialogPara.isShowDialog = false
        } else {
          this.$message.error(msg)
        }
      })
    },
    postdictionariesqueryDictionaryData (value) { //  查询增值税与关税
      let para = new URLSearchParams(
        {
          dictionaryId: value
        }
      )
      dictionariesqueryDictionaryData(para).then(res => {
        console.log(res)
        switch (value) {
          case 7: //  增值税
            this.taxRateList = res.data
            break
          case 8: //  关税
            this.tariffRateList = res.data
            break
        }
      })
    },
    postexcelgetexcel () {
      let para = new URLSearchParams(this.form)
      let responseType = {
        responseType: 'blob'
      }
      excelgetexcel(para, responseType).then(res => {
        console.log(res)
        if (!res) {
          this.$message.error('请求失败')
        } else {
          // type 为需要导出的文件类型，此处为xls表格类型
          const blob = new Blob( [res], {type: 'application/vnd.ms-excel'} )
          // 兼容不同浏览器的URL对象
          const url = window.URL || window.webkitURL || window.moxURL
          // 创建下载链接
          const downloadHref = url.createObjectURL(blob)
          // 创建a标签并为其添加属性
          let downloadLink = document.createElement('a')
          downloadLink.href = downloadHref
          downloadLink.download = this.form.startTime + ' 至 ' + this.form.endTime +  '.xls'
          // 触发点击事件执行下载
          downloadLink.click()
        }
      })
    }
  },

}
</script>

<style lang="stylus" scoped>
#profit
  .prohead
    display flex
    justify-content space-between
    .el-form-item
      display flex
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
  .flexright
    display flex
    justify-content flex-end
</style>

